import React, { memo, forwardRef, useMemo, Fragment, useCallback } from 'react';
import { createUseStyles, Badge, Link } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from 'lib/Web5Context';

import { MATCHING_VALUES } from '../../constants';

import styles from './styles';
const useStyles = createUseStyles(styles, 'StatusFormatter');

const StatusFormatter = (
    {
        getTableSchemaRef,
        onEdit,
        data,
        node,
        api,
        syncNames,
        setIsInvalid,
        controlOpenedMatchingModal,
    },
    ref,
) => {
    const classes = useStyles();
    const { t } = useWeb5Context();

    const onEditField = useCallback(() => {
        onEdit(data, node, api);
    }, [api, data, node, onEdit]);

    const badge = useMemo(() => {
        const hasExtraInfo = data.extraInfo && Object.keys(data.extraInfo).length;
        const tableSchema = getTableSchemaRef();
        const isValuelist = tableSchema?.[data.nameField]?.type === 101;

        if (syncNames.includes(data.nameField)) {
            return <Badge>{t('cfm_label_import_identifier')}</Badge>;
        } else if (!data.nameField) {
            return <Badge>{t('cfm_label_values_wont_imported')}</Badge>;
        } else if (data.nameField && !hasExtraInfo && isValuelist) {
            return (
                <Fragment>
                    <Badge type="warn">{t('cfm_label_pending_to_match')}</Badge>
                </Fragment>
            );
        } else if (data.nameField && !hasExtraInfo) {
            return (
                <Fragment>
                    <Badge type="success">{t('cfm_label_values_matched')}</Badge>
                </Fragment>
            );
        } else if (data.nameField && hasExtraInfo) {
            const notMatched = Object.keys(data.extraInfo).find(
                (key) =>
                    data.extraInfo[key] === MATCHING_VALUES.noValue ||
                    (!controlOpenedMatchingModal[data.name] &&
                        data.extraInfo[key] === MATCHING_VALUES.creatAsNew),
            );
            if (notMatched) {
                setIsInvalid && setIsInvalid(true);
                return (
                    <Fragment>
                        <Badge type="error">{t('cfm_label_values_not_matched')}</Badge>
                        <Link className={classes.editLink} onClick={onEditField}>
                            {t('cfm_action_values_edit')}
                        </Link>
                    </Fragment>
                );
            } else {
                return (
                    <Fragment>
                        <Badge type="success">{t('cfm_label_values_matched')}</Badge>
                        <Link className={classes.editLink} onClick={onEditField}>
                            {t('cfm_action_values_edit')}
                        </Link>
                    </Fragment>
                );
            }
        }
    }, [
        classes.editLink,
        data,
        onEditField,
        setIsInvalid,
        syncNames,
        t,
        getTableSchemaRef,
        controlOpenedMatchingModal,
    ]);

    return (
        <div ref={ref} className={classes.statusField}>
            {badge}
        </div>
    );
};

export default memo(forwardRef(StatusFormatter));
